import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePassForm: UntypedFormGroup;
  errorMsg: string = null;
  fieldTextType1: boolean = true;
  fieldTextType2: boolean = true;
  fieldTextType3: boolean = true;
  currentUser: string = this.authenticationService.currentUserValue.username;

  constructor(public dialog: MatDialogRef<ChangePasswordComponent>, private userService: UserService, private authenticationService: AuthenticationService, private snackbar: MatSnackBar, private spiner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.changePassForm = new UntypedFormGroup({
      currentPass: new UntypedFormControl('', [Validators.required]),
      newPass: new UntypedFormControl('', [Validators.required]),
      confirmNewPass: new UntypedFormControl('', [Validators.required])
    })
  }

  onSubmit() {
    this.errorMsg = null;
    if (this.changePassForm.status == 'INVALID') {
      this.changePassForm.markAllAsTouched();
      return;
    }
    if(!this.changePassForm.value.newPass.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)) {
      this.errorMsg = "Password must be of minimum 8 character containing at least one uppercase, one lowercase, one digit, one special character( _ @ $ )"
      return;
    }
    if (this.changePassForm.value.newPass != this.changePassForm.value.confirmNewPass) {
      this.errorMsg = "New password and confirm password does not match."
      return;
    }
    if(this.changePassForm.value.newPass == this.changePassForm.value.currentPass){
      this.errorMsg = "New password and current password cannot be same."
      return;
    }
    this.spiner.show('changePassword')
    this.authenticationService
      .login(this.authenticationService.currentUserValue.username, this.changePassForm.value.currentPass).subscribe({
        next: (data) => {
          this.userService
            .changeUserPassword(this.currentUser, this.changePassForm.value.newPass)
            .subscribe({
              next: (data: any) => {
                this.snackbar.open(data.message, 'Ok', {
                  duration: 5000
                });
                this.errorMsg = null;
                this.dialog.close();
                this.spiner.hide('changePassword')
              },
              error: (err) => {
                this.spiner.hide('changePassword')
                this.snackbar.open(err.error.message, 'Ok', {
                  duration: 5000
                });
              }
            })
        }, error: (err) => {
          this.errorMsg = "Current password is incorrect."
          this.spiner.hide('changePassword')
        }
      })

  }

  onClose() {
    this.dialog.close()
  }

  togglePassswordIcon(fieldNum: number) {
    if (fieldNum == 1) {
      this.fieldTextType1 = !this.fieldTextType1;
    } else if (fieldNum == 2) {
      this.fieldTextType2 = !this.fieldTextType2;
    } else {
      this.fieldTextType3 = !this.fieldTextType3;
    }
  }

}
